"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const common_1 = require("../common");
const common_utils_1 = require("@zapier/common-utils");
const CheckboxField = (props) => {
    const onChange = (event) => {
        const { checked } = event.target;
        props.onChange(checked);
    };
    return (common_utils_1.isolateComponent(common_1.FormLabel, { isDisabled: props.isDisabled, layout: "auto-content" },
        common_utils_1.isolateComponent(design_system_1.Checkbox, { checked: props.value, disabled: props.isDisabled, onChange: onChange }),
        props.description));
};
exports.default = CheckboxField;
